// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__20ldu","actionsCol":"EnrolledClinics_actionsCol__1UG5F"};